<!--
 * @Author: 陈绍斌 1748362428@qq.com
 * @Date: 2023-05-31 14:11:27
 * @LastEditors: 陈绍斌 1748362428@qq.com
 * @LastEditTime: 2023-06-27 16:50:37
 * @FilePath: \Vyung.Portal.Front\src\views\IndustrySolution\components\ClassicCases.vue
-->
<template>
  <div class="ClassicCases-case rn-section-gap">
    <div class="container">
      <SectionTitle
        :title="$t('solution.classic_cases_title')"
        description="CASES"
        textAlign="center"
        />
        <div class="row">
          <div v-for="(item, index) in classicCasesData" :key="index" class="col-md-6 col-6 col-lg-3 p-4 d-flex justify-content-center align-items-center" :class="[{'offset-lg-3':index===0 && classicCasesData.length==2},{'col-lg-4 offset-lg-4':index===0 && classicCasesData.length==1}]">
          <!-- <div v-for="(item, index) in classicCasesData" :key="index" class="col-md-6 col-12 col-lg-4 p-3" :class="`offset-lg-${12/(classicCasesData.length>4?3:classicCasesData.length)}`"> -->
            <!-- <img :src="item.imageBackground" alt="" class="case-img"> -->
            <div class="icon-box wrapper">
              <div class="icon-box-content">
                <img :src="item.brandIcon" alt="" class="brand-icon">
              </div>
            </div>
          </div> 
        </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '../../../components/elements/sectionTitle/SectionTitle.vue'

    export default {
        name: 'ClassicCases',
        components: { SectionTitle },
        props:{
          'classicCasesData':{
            type:Array,
            default: [],
          },
        },
        data() {
            return {
                
            }
        },
        computed: {
            classStyle() {
                if (this.classicCasesData.length === 1) return 'col-12 p-3';
                else if (this.classicCasesData.length === 2) return 'col-lg-6 col-md-6 col-sm-12 p-3';
                else if (this.classicCasesData.length === 3) return 'col-lg-4 col-md-6 col-sm-12 p-3';
                else return 'col-lg-3 col-md-6 col-sm-12 p-3';
            }
        },
        methods:{

        }
    }
</script>